
import {get} from "lodash";
export class EventDataFilterService{



  filterDataWithExpression(data:Array<any>,hasFilter: boolean, filterExpression:Object):Array<any>{
    let filteredArray: any = [];
    if(hasFilter){
      if(filterExpression.hasOwnProperty('operator')){
        switch(filterExpression['operator']){
          case 'EQ':
            filteredArray =  this.filterWithEqual(data,filterExpression);
            /*console.log("filtered data: ",JSON.stringify(filteredArray));*/
            break;
          case 'LT':
            filteredArray = this.filterWithLessThan(data,filterExpression);
            break;
          case 'GT':
            filteredArray = this.filterWithGreaterThan(data,filterExpression);
            break;
        }
      }else{
        data.forEach(element => {
          let key = filterExpression['key'];
          if(element.hasOwnProperty(key) && element[key]>0){
            filteredArray.push(element[key]);
          }
        })
      }
      return filteredArray;
    }

  }

  private filterWithLessThan(data: Array<any>, filterExpression: Object) {

  }

  private filterWithEqual(data: Array<any>, filterExpression: Object):Array<any> {
    let key = filterExpression['key'];//formKey
    let value = filterExpression['value'];//pathologyFindings
    let filteredData = data.filter(obj => {
      /*console.log("filterobj: ",JSON.stringify(obj));
      console.log(get(obj,`${filterExpression['key']}`));
      console.log(get(obj,`${filterExpression['value']}`));
      get(obj,`${filterExpression['key']}`) == get(obj,`${filterExpression['value']}`);*/
      return obj[key] === value;
    })
    // return get(item, `${get(segAnn.fieldMappings,'name')}.code`)`${filterExpression['key']}`
    return filteredData;
  }

  private filterWithGreaterThan(data: Array<any>, filterExpression: Object) {

  }
}
